import Vue from "vue";
import App from "./App";
import VCharts from "v-charts";
// import elementUI from "element-ui";
// import VeLine from "v-charts/lib/line.common";
// import echarts from "echarts";
import router from "./router";
import store from "@/store";
import iView from "view-design";
import "view-design/dist/styles/iview.css";
import "font-awesome/css/font-awesome.min.css";
import "zepto";
import "./plugins/element.js";
import './plugins/view-design'
import "element-ui/lib/theme-chalk/index.css";
import "./assets/css/simple-line-icons/simple-line-icons.css";
import "./assets/css/basic.css";
import "./assets/css/common.css";
import "./assets/css/routeBar.css";
import "./assets/css/custom.css";
import "./assets/css/space.css";
import "./assets/css/width.css";
import "./assets/css/color.css";
import "./assets/css/size.css";
import "./assets/css/table.css";
// import './assets/font/iconfont.css';
// import './assets/font/libs/iconfont.css';
import "./assets/iconfont/iconfont.css";
import "vant/lib/icon/local.css";
import * as echarts from "echarts";
import elementUI from "element-ui";
import { Message, MessageBox } from "element-ui";
import "./styles/index.less";
import "./assets/js/request.js";
import VueClipboard from "vue-clipboard2";
import ElTreeSelect from "el-tree-select";
import VConsole from 'vconsole'
// new VConsole();

Vue.use(VueClipboard);
import {
  requestPrefix,
  pageLimit,
  pageSizeOpts
} from "./assets/js/commonValue";
import routeBar from "../src/components/route-bar.vue";

import Request from "./assets/js/request";
import searchInput from "../src/components/searchInputTransfer.vue";
import "@/utils/rem.js";
import {
  Tabbar,
  TabbarItem,
  Search,
  DropdownMenu,
  DropdownItem,
  Col,
  Row,
  RadioGroup,
  Radio,
  List,
  PullRefresh,
  Tag,
  Tab,
  Tabs,
  Cell,
  CellGroup,
  Popup,
  DatetimePicker,
  Field,
  Calendar,
  Form,
  NavBar,
  Uploader,
  Loading,
  Swipe,
  SwipeItem,
  Lazyload,
  Divider,
  ImagePreview
} from "vant";
import "./_mobile/style/index.less";
import { get, post, deepClone } from "./utils";
import Driver from "driver.js";
import "driver.js/dist/driver.min.css";
Vue.prototype.$get = get;
Vue.prototype.$post = post;
Vue.prototype.$deepClone = deepClone;

Vue.use(Tabbar)
  .use(TabbarItem)
  .use(Search)
  .use(DropdownMenu)
  .use(DropdownItem)
  .use(Col)
  .use(Row)
  .use(RadioGroup)
  .use(Radio)
  .use(List)
  .use(PullRefresh)
  .use(Tag)
  .use(Tab)
  .use(Tabs)
  .use(Cell)
  .use(CellGroup)
  .use(Popup)
  .use(DatetimePicker)
  .use(Field)
  .use(Calendar)
  .use(Form)
  .use(NavBar)
  .use(Uploader)
  .use(Loading)
  .use(Swipe)
  .use(SwipeItem)
  .use(Lazyload)
  .use(ImagePreview)
  .use(Divider)
  .use(ElTreeSelect)
  .use(VCharts);

Vue.config.productionTip = false;
Vue.prototype.$message = Message;
Vue.prototype.$MessageBox = MessageBox;
Vue.prototype.$prefix = requestPrefix;
Vue.prototype.$request = Request;
Vue.prototype.$pageLimit = pageLimit;
Vue.prototype.$pageSizeOpts = pageSizeOpts;
Vue.prototype.$echarts = echarts;
Vue.use(iView);
Vue.use(elementUI);
Vue.use(ElTreeSelect);
Vue.use(VCharts);
// Vue.use(elementUI);
// Vue.component(VeLine.name, VeLine);
Vue.component("route-bar", routeBar);
Vue.component("search-input", searchInput);

/* eslint-disable no-new */
new Vue({
  el: "#app",
  router,
  store,
  components: { App },
  template: "<App/>",
  created: function() {
    // console.log(666, location.href);
    if (!window.sessionStorage) {
      alert("浏览器不支持sessionStorage");
    } else {
      // 非异常处理钉钉页面和客户需求登记页面 进行token校验
      if (!location.href.includes('abnormalForm-dingTalk') && !location.href.includes('addRepairCustomer')  && (sessionStorage.token == null || sessionStorage.token === "")) {
        console.warn('main.js 检测到没有token')
        if (location.href.includes("/mobile")) {
          this.$router.push(location.href.split("#")[1]);
          // this.$router.push('/mobile/login');
          return;
        }
        if (
          location.href.includes("/customerManage/customerSatisfactionEdit")
        ) {
          this.$router.push(location.href.split("#")[1]);
          return;
        }
        if (location.href.indexOf("mobile") > -1) {
          this.$router.push(location.href.split("#")[1]);
          return;
        }
        if (location.href.indexOf("auth") > -1) {
          this.$router.push(location.href.split("#")[1]);
          return;
        }
        //判断是普通用户还是管理员
        let userType = sessionStorage.userType;
        if (userType === "superAdmin") {
          this.$router.push("/adminLogin");
        } else {
          let href = location.href;
          if (href.indexOf("admin") > -1) {
            this.$router.push("/adminLogin");
          } else {
            let array = href.split("#");
            if (array.length > 1 && array[1].indexOf("login") > -1) {
            } else {
              this.$router.push("/login");
            }
          }
        }
      }
    }
  }
});
//点击跳转的（即需要点击后跳转的路由） 权限通过在这里配置
router.beforeEach((to, from, next) => {
  // console.log(777,to);
  sessionStorage.setItem("beforePath", from.fullPath);

  // console.log(sessionStorage.getItem('wxUserInfo'))
  if(sessionStorage.getItem('wxUserInfo')){
    console.log("存在")
  }
  if (
    to.fullPath.indexOf("/login") > -1 ||
    to.fullPath === "/adminLogin" ||
    to.path === "/mobile/login" ||
    to.path === "/mobile/dingLogin" ||
    to.path === "/wechat/auth" ||
    to.path === "/mobile/mobileCustomerSatisfactionEdit" ||
    (to.path === "/mobile/addRepairCustomer") ||  //客户需求登记
    (to.path === "/mobile/repairCustomerIndex") ||  //前端路由跳转-from跳转to；该位置是配置to的地址不需要登录验证
    (to.path === "/mobile/repairCustomerList") || //客户需求登记详情与编辑
    (to.path === "/mobile/mobileAfterSaleChatLLM") || //移动端对接内网的llm服务
    (to.path === "/mobile/viewAndEditRepairCustomer") || //客户需求登记详情与编辑
    // to.path === "/mobile/troubleshoot/index" ||   //故障查询路由 这个位置加暂时失效，需要到roter/index.js中进行路由通过
    to.path === "/dingTalk/auth" ||
    to.path === "/customerManage/customerSatisfactionEdit" ||
    to.path === "/mobile/errorMessageDetail"
  ) {
    next();
    return false;
  }
  if (!window.sessionStorage) {
    alert("浏览器不支持sessionStorage");
  } else {
    if (/^\/mobile/.test(to.path)) {
      if (sessionStorage.token != null && sessionStorage.token != "") {
        next();
        return "";
      } else {
        if (sessionStorage.loginType == "dingLogin") {
          next({
            path: "/mobile/dingLogin"
          });
        } else {
          next({
            path: "/mobile/login"
          });
        }

        alert("对不起，您尚未登录，请先登录！");
        return "";
      }
    }
    // if (/^\/auth/.test(to.path)) {
    //   next({
    //     path: "/wechat/auth"
    //   });
    // }
    if (sessionStorage.token != null && sessionStorage.token != "") {
      next();
      return "";
    } else {
      let userType = sessionStorage.userType;
      if (userType == "superAdmin") {
        next({
          path: "/adminLogin"
        });
        alert("对不起，您尚未登录，请先登录！");
        return "";
      } else if (userType == "user") {
        next({
          path: "/login"
        });
        alert("对不起，您尚未登录，请先登录！");
        return "";
      } else {
        if (to.fullPath.indexOf("admin") > -1) {
          next({
            path: "/adminLogin"
          });
          alert("对不起，您尚未登录，请先登录！");
          return "";
        } else {
          next({
            path: "/login"
          });
          alert("对不起，您尚未登录，请先登录！");
          return "";
        }
      }
    }
  }
  next();
});

router.onError(error => {
  const pattern = /Loading chunk (\d)+ failed/g;
  const isChunkLoadFailed = error.message.match(pattern);
  const targetPath = router.history.pending.fullPath;
  console.log("路由错误");
  if (isChunkLoadFailed) {
    console.log("进入");
    router.replace(targetPath);
  }
});



// WEBPACK FOOTER //
// ./src/main.js